const PARENTAL_LOCK_PREFIX = '@PARENTAL_LOCK';

export const SAVE_PIN = `${PARENTAL_LOCK_PREFIX}/SAVE_PIN`;
export const SAVE_PIN_SUCCESS = `${PARENTAL_LOCK_PREFIX}/SAVE_PIN_SUCCESS`;

export const CHECK_PIN = `${PARENTAL_LOCK_PREFIX}/CHECK_PIN`;
export const CHECK_PIN_SUCCESS = `${PARENTAL_LOCK_PREFIX}/CHECK_PIN_SUCCESS`;
export const CHECK_PIN_ERROR = `${PARENTAL_LOCK_PREFIX}/CHECK_PIN_ERROR`;

export const SET_PIN = `${PARENTAL_LOCK_PREFIX}/SET_PIN`;
export const SET_PIN_SUCCESS = `${PARENTAL_LOCK_PREFIX}/SET_PIN_SUCCESS`;
export const SET_PIN_ERROR = `${PARENTAL_LOCK_PREFIX}/SET_PIN_ERROR`;

export const SET_PURCHASE = `${PARENTAL_LOCK_PREFIX}/SET_PURCHASE`;

export const SET_AGE = `${PARENTAL_LOCK_PREFIX}/SET_AGE`;

export const SET_ENABLED = `${PARENTAL_LOCK_PREFIX}/SET_ENABLED`;
